import { Button, Card, CardContent, Grid, TextareaAutosize, Typography } from "@mui/material";
import React, { useState } from "react";
import { FormSectionHeader } from "../../Shared/FormSectionHeader";

export const ApprovedActions = (
    callback: (() => void) | undefined,
    closeCallback: (cancellationReason: string) => void
) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [cancellationReason, setCancellationReason] = useState<string>("");

    const onClose = (cancellationReason: string) => {
        setLoading(true);
        if (closeCallback)
            closeCallback(cancellationReason);
    };



    return (<Card>
        <FormSectionHeader label="Ready For Dispatch" />
        <CardContent>
            <Grid container>
                <Grid xs={10} item>
                    <Typography variant="subtitle1">
                        The dispatch request was approved. Once material has been picked, you can mark the request as ready for dispatching.
                    </Typography>
                </Grid>
                <Grid xs={2} container alignItems="center" justifyContent="right" item>
                    <Button variant="contained" onClick={callback ? () => callback() : undefined} disabled={callback === undefined}>
                        Ready for Dispatch
                    </Button>
                </Grid>
            </Grid>
            <Grid container>
                <Grid xs={10} item>
                    <Typography variant="subtitle2">Cancel Dispatch Request</Typography>
                    <TextareaAutosize
                        placeholder="Enter a Cancellation Reason"
                        minRows={2}
                        style={{
                            borderRadius: '5px',
                            borderColor: '#ccc',
                            minWidth: '620px',
                            padding: '.5em'
                        }}
                        value={cancellationReason}
                        onChange={(e) => setCancellationReason(e.target.value)} />
                </Grid>
                <Grid xs={2} container alignItems="center" justifyContent="right" item>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={() => onClose(cancellationReason)}
                        disabled={loading || cancellationReason.length < 1}>Cancel</Button>
                </Grid>
            </Grid>
        </CardContent>
    </Card>);
};
